/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/collection/filter-brand-fix.js":
/*!***********************************************!*\
  !*** ./src/js/collection/filter-brand-fix.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = filterBrandFix;
function filterBrandFix() {
  var hiddenBrands = ["ADIRNYC JEWELRY", "Adwar Casting", "AFFINITY DESIGNS LLC", "AFFORADABLE GEMS (NY) CORP.", "AFFORDABLE GEMS (NY) CORP.", "ALICIA VAN FLETEREN", "Amden Jewelry", "American Jewelry Designs", "ARMADANI", "ARTISTRY, LTD", "Arya's Collection", "Ashi Diamonds, LLC", "Atelier d'Excellence Inc.", "Atlantic Diamond Company", "Barry Davidson, Inc.", "Belgium Diamond", "BELLARRI", "Bhanderi Lab Grown Diamonds Inc.", "C&C Jewelry Mfg., Inc.", "Carrera Casting Corp.", "China Pearl", "Cool And Interesting", "Coronation cultured pearls", "Dalumi Diamond Corporation", "DASSARI", "David Kord (Formerly A & D)", "Dharm International", "DIALOG SOLUTIONS INC", "Diamond Imports Inc.", "Diamonds Forever of USA, Inc.", "Divine LLC", "ELAN JEWELS LLC", "ELYSIAN DESIGNS INC", "EMA Jewelry", "Equity Diamond LLC Dba EDB", "Essential Lab Grown Diamonds Inc.", "Fischer Jewelry Designs", "Frederick Goldman", "FREMADA GOLD INC.", "Gemsone corporation", "Genuine Gems Corp.", "GIFT Classic of New York", "GIFT INOX Jewelry / SalesONE LLC", "GIFT Kenro Industries- Ballast", "GRAHAM INTERNATIONAL, INC.", "Guild+Facet", "H.j. Namdar", "Harout R", "HEERA MOTI", "HERCO", "HMA CREATIONS LLC", "I. Reiss Company", "INDIGO JEWELRY", "International Diamond Distributors", "JEWELS BY JACOB", "JOCALIO GROUP LLC", "Joshua J. Fine Jewelry", "K.P. Sanghvi Inc.", "KIran Gems NY Inc.", "Lieberfarb, Inc.", "M.K. Diamonds & Jewelry", "Malakan Diamond Company", "Marks Jewelers", "Marks Jewelers Levittown", "Marks Jewelers Montgomeryville", "Marks Luxry Handbags", "Marque", "Mercury Ring", "Metal Market Intl", "Midas Chain", "Mondrian Collection", "Nemorofsky", "Ofer Mizrahi JEWELRY", "ORIGINAL DESIGNS", "OVERNIGHT MOUNTINGS", "Overseas Direct, Member of Salant Group", "Quality Gold", "R.A. Riam Group Inc.", "REVELATION-Craft Lab Grown Diamonds", "Royal Jewelry Manufacturing Inc.", "Royal Pearl", "S. KASHI", "Saban Onyx", "SABRINA DESIGNS CO.", "Samuel B. Collection", "Sandberg & Sikorsk", "SDC Creations", "SMILING ROCKS, INC", "Speidel Inc.", "Stock Jewlvision - Made in Montgomeryville", "Stuller", "Universal Pacific Diamonds", "Venetti", "VIMCO DIAMOND CORP.", "VLORA", "Yerushalmi Brothers"];
  var brandDetails = document.querySelectorAll('.facets__disclosure > .facets__summary > span');
  brandDetails.forEach(function (brandDetail) {
    if (brandDetail.textContent.trim() === 'Brand') {
      var labelList = brandDetail.closest('.facets__disclosure').querySelectorAll('.facets__display ul li label');
      labelList.forEach(function (label) {
        hiddenBrands.forEach(function (hiddenBrand) {
          var labelContent = label.textContent.trim().toLowerCase();
          var isHiddenBrandIncluded = labelContent.includes(hiddenBrand.toLowerCase());
          if (isHiddenBrandIncluded) {
            label.remove();
          }
        });
      });
    }
  });
}

/***/ }),

/***/ "./src/js/collection/filter-display.js":
/*!*********************************************!*\
  !*** ./src/js/collection/filter-display.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = filterDisplay;
function filterDisplay() {
  var facetCount = 5;
  if (window.innerWidth < 992) {
    facetCount = 2;
  }
  var productCountElem = document.querySelector('#ProductCountDesktop');
  var totalItems;
  if (productCountElem) {
    // eslint-disable-next-line prefer-destructuring
    totalItems = productCountElem.textContent.split(' ')[0];
  }
  var activeFacetsElem = document.querySelector('.active-facets');
  // Hides "Active Filters" and "Clear All Filters" elements if no filters are applied
  if (!document.querySelector('.activeFilters__wrap > facet-remove') && activeFacetsElem) {
    activeFacetsElem.style.display = 'none';
  }

  // Removes all filter checkboxes that will filter down to zero items
  if (document.querySelector('.list-menu__item.facets__item')) {
    document.querySelectorAll('.list-menu__item.facets__item').forEach(function (elem) {
      if (elem.querySelector('label').textContent.trim().split('(')[1].split(')')[0] === '0') {
        elem.remove();
      }
    });
  }
  var allFacetElems = document.querySelectorAll('.facets__disclosure');
  if (document.querySelector('.facets__disclosure')) {
    allFacetElems.forEach(function (elem) {
      // Removes facet element if it will not filter out any items
      // Only triggers if total items in Collection matches number of items in filter
      if (elem.querySelectorAll('.facet-checkbox').length === 1) {
        var filterItems = elem.querySelector('.facet-checkbox').textContent.trim().split('(')[1].replace(')', '');
        if (totalItems === filterItems) {
          elem.remove();
        }
      }

      // Removes Ring Type 2 facet element on all Collections
      if (elem.querySelector('.facets__summary span').textContent === 'Ring Type 2') {
        elem.remove();
      }

      // Removes Brand facet element on Luxury Handbags Collection
      if (window.location.pathname.includes('luxury-handbags') && elem.querySelector('.facets__summary span').textContent === 'Brand') {
        elem.remove();
      }
      if (window.location.pathname.includes('estate') && elem.querySelector('.facets__summary span').textContent === 'Ring Style') {
        elem.querySelector('.facets__summary span').textContent = 'Jewelry Type';
      }
    });

    // Redefining all facets variable after removing and modifying various elements
    allFacetElems = document.querySelectorAll('.facets__disclosure');

    // Removes all empty facets
    allFacetElems.forEach(function (elem, i) {
      if (elem.querySelector('span').textContent.toLowerCase() !== 'price' && !elem.querySelectorAll('.facets__item').length) {
        elem.remove();
      }
      if (i >= facetCount) {
        elem.classList.add('hide-facet');
      }
    });
  }
  var dropButtonElem = document.querySelector('#dropbutton');
  if (dropButtonElem) {
    dropButtonElem.innerHTML = 'Show More Filters <span class="show-more-glyph">+</span>';

    // Logic to toggle "Show More" and "Show Less" button text starts here
    dropButtonElem.addEventListener('click', function (e) {
      if (e.target.closest('#dropbutton').textContent.toLowerCase().includes('more')) {
        dropButtonElem.innerHTML = 'Show Less Filters <span class="show-less-glyph">-</span>';

        // Redefining all facets variable after removing and modifying various elements
        allFacetElems = document.querySelectorAll('.facets__disclosure');

        // Shows all facets when "Show More" is clicked
        allFacetElems.forEach(function (elem, i) {
          if (i >= facetCount) {
            elem.classList.remove('hide-facet');
          }
        });
      } else {
        dropButtonElem.innerHTML = 'Show More Filters <span class="show-more-glyph">+</span>';
        allFacetElems.forEach(function (elem, i) {
          if (i >= facetCount) {
            elem.classList.add('hide-facet');
          }
        });
      }
    });
  }
  var collectionFiltersElem = document.querySelector('#main-collection-filters');

  // Displays the element containing all facets only after all logic has executed
  // The timeout matches the initial transition effect duration
  if (collectionFiltersElem && collectionFiltersElem.classList.contains('start-invis')) {
    setTimeout(function () {
      collectionFiltersElem.classList.remove('start-invis');
    }, 600);
  }
}

/***/ }),

/***/ "./src/js/collection/filter-refresh.js":
/*!*********************************************!*\
  !*** ./src/js/collection/filter-refresh.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = filterRefresh;
function filterRefresh() {
  // Refreshes page after clicking a facet checkbox
  if (document.querySelector('label.facet-checkbox')) {
    document.querySelectorAll('label.facet-checkbox').forEach(function (elem) {
      elem.addEventListener('click', function () {
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      });
    });
  }

  // Refreshes page after clearing facets
  if (document.querySelector('facet-remove')) {
    document.querySelectorAll('facet-remove').forEach(function (elem) {
      elem.addEventListener('click', function () {
        setTimeout(function () {
          window.location.reload();
        }, 500);
      });
    });
  }

  // Refreshes page after selection a new sort by filter
  if (document.querySelector('select[name="sort_by"]')) {
    document.querySelectorAll('select[name="sort_by"]').forEach(function (elem) {
      elem.addEventListener('change', function () {
        setTimeout(function () {
          window.location.reload();
        }, 500);
      });
    });
  }

  // Logic for properly refreshing price facet starts here
  var gteInput = document.querySelector('input[name="filter.v.price.gte"]');
  var lteInput = document.querySelector('input[name="filter.v.price.lte"]');
  var gteInputValue;
  var lteInputValue;
  if (gteInput && lteInput) {
    /* eslint-disable prefer-destructuring */
    gteInput.value = gteInput.value.split('.')[0];
    lteInput.value = lteInput.value.split('.')[0];
    /* eslint-enable prefer-destructuring */

    gteInputValue = document.querySelector('input[name="filter.v.price.gte"]').value;
    lteInputValue = document.querySelector('input[name="filter.v.price.lte"]').value;

    // Executes code when minimum price value is unfocused/blurred
    // Does nothing if maximum price value element is focused next
    // Also does nothing if neither minimum nor maximum values have changed
    gteInput.addEventListener('blur', function () {
      setTimeout(function () {
        if (document.querySelector('#Filter-Price-LTE') === document.activeElement) return;
        if (gteInputValue !== document.querySelector('input[name="filter.v.price.gte"]').value || lteInputValue !== document.querySelector('input[name="filter.v.price.lte"]').value) {
          setTimeout(function () {
            window.location.reload();
          }, 500);
        }
      }, 50);
    });

    // Executes code when maximum price value is unfocused/blurred
    // Does nothing if minimum price value element is focused next
    // Also does nothing if neither minimum nor maximum values have changed
    lteInput.addEventListener('blur', function () {
      setTimeout(function () {
        if (document.querySelector('#Filter-Price-GTE') === document.activeElement) return;
        if (lteInputValue !== document.querySelector('input[name="filter.v.price.lte"]').value || gteInputValue !== document.querySelector('input[name="filter.v.price.gte"]').value) {
          setTimeout(function () {
            window.location.reload();
          }, 500);
        }
      }, 50);
    });
  }
}

/***/ }),

/***/ "./src/js/collection/luxury-handbag-titles.js":
/*!****************************************************!*\
  !*** ./src/js/collection/luxury-handbag-titles.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = luxuryHandbagTitles;
function luxuryHandbagTitles() {
  if (window.location.href.includes('/luxury-handbags')) {
    var designerArray = [];
    document.querySelectorAll('#FacetsWrapperDesktop .facets__disclosure .facets__summary span').forEach(function (elem) {
      if (elem.textContent === 'Designer') {
        elem.closest('.facets__disclosure').querySelectorAll('.facets__display .facets__item').forEach(function (item) {
          designerArray.push(item.textContent.split('(')[0].trim());
        });
      }
    });
    document.querySelectorAll('.card__heading a').forEach(function (elem) {
      designerArray.forEach(function (item) {
        if (elem.textContent.includes(item)) {
          elem.textContent = elem.textContent.replace(item, '');
        }
      });
    });
  }
}

/***/ }),

/***/ "./src/js/collection/navbar-fix.js":
/*!*****************************************!*\
  !*** ./src/js/collection/navbar-fix.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = navbarFix;
function navbarFix() {
  document.addEventListener('scroll', function (event) {
    if (window.location.href.includes('lagos-fine-jewelry')) {
      if (window.pageYOffset > 3460) {
        document.querySelector('#main-collection-filters').classList.add('navbar-fixed');
      }
      if (window.pageYOffset < 3460) {
        document.querySelector('#main-collection-filters').classList.remove('navbar-fixed');
      }
    } else {
      if (window.pageYOffset > 215) {
        document.querySelector('#main-collection-filters').classList.add('navbar-fixed');
      }
      if (window.pageYOffset < 216) {
        document.querySelector('#main-collection-filters').classList.remove('navbar-fixed');
      }
    }
  });
}

/***/ }),

/***/ "./src/js/collection/promo-banners.js":
/*!********************************************!*\
  !*** ./src/js/collection/promo-banners.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = promoBanners;
function promoBanners() {
  if (document.querySelector('.activeFilters__wrap > facet-remove')) return;
  function placeDesktopPromoCard(image, link, page, row, begin, end, cardClass) {
    if (window.innerWidth <= 990) return;
    if (!image || !page || !row || !begin || !end) return;
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var pageParam = urlParams.get('page');
    if (parseInt(page, 10) !== parseInt(pageParam, 10)) return;
    var promoCard = document.createElement('a');
    promoCard.classList.add('promo__card', 'grid__item', cardClass);
    promoCard.style.backgroundImage = "url(".concat(image, ")");
    promoCard.style.gridColumn = "".concat(parseInt(begin, 10), "/").concat(parseInt(end, 10) + 1);
    promoCard.style.gridRow = "".concat(parseInt(row, 10), "/").concat(parseInt(row, 10));
    promoCard.setAttribute('href', link);
    document.querySelectorAll('#product-grid .grid__item')[0].before(promoCard);
  }

  /* eslint-disable */

  placeDesktopPromoCard(desktopPromoCardOneImgURL, desktopPromoCardOneURL, desktopPromoCardOnePage, desktopPromoCardOneRow, desktopPromoCardOneBegin, desktopPromoCardOneEnd, desktopPromoCardOneClass);
  placeDesktopPromoCard(desktopPromoCardTwoImgURL, desktopPromoCardTwoURL, desktopPromoCardTwoPage, desktopPromoCardTwoRow, desktopPromoCardTwoBegin, desktopPromoCardTwoEnd, desktopPromoCardTwoClass);
  placeDesktopPromoCard(desktopPromoCardThreeImgURL, desktopPromoCardThreeURL, desktopPromoCardThreePage, desktopPromoCardThreeRow, desktopPromoCardThreeBegin, desktopPromoCardThreeEnd, desktopPromoCardThreeClass);
  placeDesktopPromoCard(desktopPromoCardFourImgURL, desktopPromoCardFourURL, desktopPromoCardFourPage, desktopPromoCardFourRow, desktopPromoCardFourBegin, desktopPromoCardFourEnd, desktopPromoCardFourClass);

  /* eslint-enable */

  function placeDesktopPromoBanner(image, link, page, row, bannerClass) {
    if (window.innerWidth <= 990) return;
    if (!image || !page || !row) return;
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var pageParam = urlParams.get('page');
    if (parseInt(page, 10) !== parseInt(pageParam, 10)) return;
    var promoBanner = document.createElement('a');
    promoBanner.classList.add('wide__item', bannerClass);
    promoBanner.style.backgroundImage = "url(".concat(image, ")");
    promoBanner.style.gridRow = "".concat(row, "/").concat(row);
    promoBanner.setAttribute('href', link);
    document.querySelectorAll('#product-grid .grid__item')[0].after(promoBanner);
  }

  /* eslint-disable */

  placeDesktopPromoBanner(desktopPromoBannerOneImgURL, desktopPromoBannerOneURL, desktopPromoBannerOnePage, desktopPromoBannerOneRow, desktopPromoBannerOneClass);
  placeDesktopPromoBanner(desktopPromoBannerTwoImgURL, desktopPromoBannerTwoURL, desktopPromoBannerTwoPage, desktopPromoBannerTwoRow, desktopPromoBannerTwoClass);
  placeDesktopPromoBanner(desktopPromoBannerThreeImgURL, desktopPromoBannerThreeURL, desktopPromoBannerThreePage, desktopPromoBannerThreeRow, desktopPromoBannerThreeClass);
  placeDesktopPromoBanner(desktopPromoBannerFourImgURL, desktopPromoBannerFourURL, desktopPromoBannerFourPage, desktopPromoBannerFourRow, desktopPromoBannerFourClass);

  /* eslint-enable */

  function placeMobilePromoCard(image, link, page, row, position, cardClass) {
    if (window.innerWidth >= 991) return;
    if (!image || !page || !row || !position) return;
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var pageParam = urlParams.get('page');
    if (parseInt(page, 10) !== parseInt(pageParam, 10)) return;
    var promoCard = document.createElement('a');
    promoCard.classList.add('promo__card-mobile', 'grid__item', cardClass);
    promoCard.style.backgroundImage = "url(".concat(image, ")");
    promoCard.style.gridColumn = "".concat(parseInt(position, 10), "/").concat(parseInt(position, 10));
    promoCard.style.gridRow = "".concat(parseInt(row, 10), "/").concat(parseInt(row, 10));
    promoCard.setAttribute('href', link);
    document.querySelectorAll('#product-grid .grid__item')[0].before(promoCard);
  }

  /* eslint-disable */

  placeMobilePromoCard(mobilePromoCardOneImgURL, mobilePromoCardOneURL, mobilePromoCardOnePage, mobilePromoCardOneRow, mobilePromoCardOnePosition, mobilePromoCardOneClass);
  placeMobilePromoCard(mobilePromoCardTwoImgURL, mobilePromoCardTwoURL, mobilePromoCardTwoPage, mobilePromoCardTwoRow, mobilePromoCardTwoPosition, mobilePromoCardTwoClass);
  placeMobilePromoCard(mobilePromoCardThreeImgURL, mobilePromoCardThreeURL, mobilePromoCardThreePage, mobilePromoCardThreeRow, mobilePromoCardThreePosition, mobilePromoCardThreeClass);
  placeMobilePromoCard(mobilePromoCardFourImgURL, mobilePromoCardFourURL, mobilePromoCardFourPage, mobilePromoCardFourRow, mobilePromoCardFourPosition, mobilePromoCardFourClass);

  /* eslint-enable */

  function placeMobilePromoBanner(image, link, page, row, bannerClass) {
    if (window.innerWidth >= 991) return;
    if (!image || !page || !row) return;
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var pageParam = urlParams.get('page');
    if (parseInt(page, 10) !== parseInt(pageParam, 10)) return;
    var promoBanner = document.createElement('a');
    promoBanner.classList.add('wide__item-mobile', bannerClass);
    promoBanner.style.backgroundImage = "url(".concat(image, ")");
    promoBanner.style.gridRow = "".concat(row, "/").concat(row);
    promoBanner.setAttribute('href', link);
    document.querySelectorAll('#product-grid .grid__item')[0].after(promoBanner);
  }

  /* eslint-disable */

  placeMobilePromoBanner(mobilePromoBannerOneImgURL, mobilePromoBannerOneURL, mobilePromoBannerOnePage, mobilePromoBannerOneRow, mobilePromoBannerOneClass);
  placeMobilePromoBanner(mobilePromoBannerTwoImgURL, mobilePromoBannerTwoURL, mobilePromoBannerTwoPage, mobilePromoBannerTwoRow, mobilePromoBannerTwoClass);
  placeMobilePromoBanner(mobilePromoBannerThreeImgURL, mobilePromoBannerThreeURL, mobilePromoBannerThreePage, mobilePromoBannerThreeRow, mobilePromoBannerThreeClass);
  placeMobilePromoBanner(mobilePromoBannerFourImgURL, mobilePromoBannerFourURL, mobilePromoBannerFourPage, mobilePromoBannerFourRow, mobilePromoBannerFourClass);

  /* eslint-enable */
}

/***/ }),

/***/ "./src/js/collection/set-page-id.js":
/*!******************************************!*\
  !*** ./src/js/collection/set-page-id.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setPageId;
function setPageId() {
  var currentPage = 1;
  if (!window.location.href.includes('page=')) {
    if (document.querySelector('.pagination__item--current')) {
      currentPage = document.querySelector('.pagination__item--current').textContent.trim();
    }
    var nextTitle = document.getElementsByTagName('title')[0].innerHTML.replace('\n', ' ');
    var nextState = {
      additionalInformation: 'Updated the URL with JS'
    };
    var nextURL;
    if (!window.location.href.includes('?')) {
      nextURL = "".concat(window.location.href, "?page=").concat(currentPage);
    } else {
      nextURL = "".concat(window.location.href, "&page=").concat(currentPage);
    }
    window.history.replaceState(nextState, nextTitle, nextURL);
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!******************************!*\
  !*** ./src/js/collection.js ***!
  \******************************/


var _navbarFix = _interopRequireDefault(__webpack_require__(/*! ./collection/navbar-fix */ "./src/js/collection/navbar-fix.js"));
var _setPageId = _interopRequireDefault(__webpack_require__(/*! ./collection/set-page-id */ "./src/js/collection/set-page-id.js"));
var _promoBanners = _interopRequireDefault(__webpack_require__(/*! ./collection/promo-banners */ "./src/js/collection/promo-banners.js"));
var _filterRefresh = _interopRequireDefault(__webpack_require__(/*! ./collection/filter-refresh */ "./src/js/collection/filter-refresh.js"));
var _filterDisplay = _interopRequireDefault(__webpack_require__(/*! ./collection/filter-display */ "./src/js/collection/filter-display.js"));
var _luxuryHandbagTitles = _interopRequireDefault(__webpack_require__(/*! ./collection/luxury-handbag-titles */ "./src/js/collection/luxury-handbag-titles.js"));
var _filterBrandFix = _interopRequireDefault(__webpack_require__(/*! ./collection/filter-brand-fix */ "./src/js/collection/filter-brand-fix.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(0, _navbarFix.default)();
(0, _setPageId.default)();
(0, _promoBanners.default)();
(0, _filterRefresh.default)();
(0, _filterDisplay.default)();
(0, _luxuryHandbagTitles.default)();
(0, _filterBrandFix.default)();
})();

/******/ })()
;

/* Filter Dropdown */

if (window.innerWidth > 991){
  $("#Details-1-main-collection .facets__summary").addClass('open');
}

$(".facets__summary").click(function(){
  $(this).toggleClass('open');
  $(this).next(".facets__display").slideToggle();
});

/* Filter Follow Scroll */

const filterFromTop = $("#main-collection-filters").offset().top;
const paginationFromTop = $("#pagination").offset().top;

if(window.innerWidth > 1023){ //only on desktop

  $(document).scroll(function () {
    let scrollDistance = $(document).scrollTop();
    let filterHeight = $("#main-collection-filters").height();
    let maxScroll = paginationFromTop - filterHeight;
    let filterOffset = maxScroll - scrollDistance;

    if(scrollDistance > (filterFromTop - 155)){ //if scroll position is at top of filter
      $("#main-collection-filters").css({"position":"fixed","top":"155px"});

      if(scrollDistance > (maxScroll - 245)){ //if scroll position has filter at bottom of page
        $("#main-collection-filters").css({"top":(filterOffset - 90 )});
      }

    } else{
      $("#main-collection-filters").css({"position":"absolute","top":"0"});
    }
  });

}

/* Collection Description Accordion */

const descriptionDiv = document.getElementById('productCollectionDescription');
const toggleButton = document.getElementById('productCollectionDescriptionButton');

// Store the original height of the div
const originalHeight = descriptionDiv.scrollHeight;

// Set the max height
let maxHeight = 27;
if (window.innerWidth < 1024) {
    maxHeight = 72;
}
descriptionDiv.style.maxHeight = maxHeight + 'px';

// Toggle the max height on button click
toggleButton.addEventListener('click', function() {
    if (descriptionDiv.style.maxHeight === maxHeight + 'px') {
        descriptionDiv.style.maxHeight = originalHeight + 'px';
        toggleButton.classList.add("open");
        toggleButton.classList.remove("close");
    } else {
        descriptionDiv.style.maxHeight = maxHeight + 'px';
        toggleButton.classList.add("close");
        toggleButton.classList.remove("open");
    }
});

